import config from '../config.js'
import { ref} from "vue"

/**
 * Laden des Json und aufbereiten der Produktdaten, Filter, Sortierung, Übersetzung, Marken
 * @param cfg
 * @returns {{brands: Ref<UnwrapRef<{}>>, GlassesList: Ref<UnwrapRef<*[]>>, sorting: Ref<UnwrapRef<{}>>, translation: Ref<UnwrapRef<{}>>, filters: Ref<UnwrapRef<{}>>, fetchGlasses: fetchGlasses}}
 */
export function fetchJsonObject() {
    function getDateStr() {
      const cur = new Date()
      return cur.getFullYear().toString() + cur.getMonth().toString() + cur.getDate().toString()
    }
    const hasError = ref(false);
    const Article = ref({isloaded: false, article_nr: '', colors: []});
    const GlassesList = ref([Article])
    const translation = ref({})
    const lastResponse = ref({
        list: process.env.NODE_ENV === 'development' ?  config.jsonUrl + '?v=' + getDateStr(): config.prodRelativeUrl + config.jsonUrl + '?v=' + getDateStr()
    })
    fetchGlasses()

    /**
     * Json abholen und Datenobjekte bereitstellen
     * @param cfg
     */
    function fetchGlasses() {
        hasError.value = true
        fetch(lastResponse.value.list)
            .then(response => response.json())
            .then(data => {
                hasError.value = false
                GlassesList.value.push(...data.itemlist)
                translation.value = data.translation
            })

    }
    return {
        hasError,
        GlassesList,
        translation
    }
}
